import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import './index.css';
import './common/util/froalaOverrides.css';
import './common/util/tanstack-table.css';
import '@on24/speaker-cards/all-locales';
import { router } from './appLayout/router';
import '@on24/webawesome-pro/dist/webawesome.loader.js';
import '@on24/design-system-admin/styles-minimal.css';
import '@on24/elite-reg-form/dist/index.css';

if (typeof global === 'undefined') {
  // eslint-disable-next-line no-global-assign
  window.global = window;
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<RouterProvider router={router} />);
